import Icon from '../../components/Icon.vue'

Icon.register({"brands/yahoo":{"width":448,"height":512,"paths":[{"d":"M252 292L256 512C243.3 509.8 232.5 508.1 223.7 508.1 215.3 508.1 204.5 509.8 191.4 512L195.4 292C140.4 197.2 85 95.2 21.4 0 33.3 3.1 44.4 3.9 54.6 3.9 63.6 3.9 75 3.1 88.7 0 129.6 72.2 170.8 138.7 223.7 225.5 261 163.9 314.8 81.4 358.6 0 369.7 2.9 380.6 3.9 391.5 3.9 403 3.9 414.7 2.9 426.5 0 392.1 47.9 294.9 216.9 252 292z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/yahoo.js
// module id = JD5F
// module chunks = 0